

import FireLoginStatus from "../../../Lib/Firebase/FireLoginStatus";
import AdminSettings from "../../AdminSettings/AdminSettings";

import "./AdminPage.css"

require("dotenv").config()

const AdminPage = () => {


  // ADMIN PAGE JUST CHECKS IF YOU ARE AN ADMIN OR NOT

  let [user] = FireLoginStatus()

 
  let ADMIN_USER

  if(user){
    ADMIN_USER=user.uid
  }else{
    ADMIN_USER=""
  }
  
  return ( 
    <div className="AdminPage">
      <main className="AdminPage__main">

        {

          `${process.env.REACT_APP_ADMIN_UID}`===ADMIN_USER ||
          `${process.env.REACT_APP_ADMIN_UID2}`===ADMIN_USER ||
          `${process.env.REACT_APP_ADMIN_UID3}`===ADMIN_USER ||
          `${process.env.REACT_APP_ADMIN_UID4}`===ADMIN_USER
          ?
          
          <AdminSettings/>
          
          :"you're not an admin"
        }

      </main>
    </div>
   );
}
 
export default AdminPage;